import { createFileRoute } from '@tanstack/react-router'

import {Authorisation} from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import {ROLES} from "@/lib/auth/roles";
import PerformanceAdviser from "@/modules/performance/adviser";
import {
  ELEVATION_PERFORMANCE_ADVISER_PATH, ELEVATION_PERFORMANCE_ADVISER_URL
} from "@/utils/urls";

export const Route = createFileRoute(ELEVATION_PERFORMANCE_ADVISER_PATH)({
  component: PerformanceAdviserPage,
  beforeLoad: () => {
    return {
      breadcrumbs: [
        { label: 'Adviser performance', path: '#' },
        { label: 'Compare advisers', path: ELEVATION_PERFORMANCE_ADVISER_URL },
      ]
    }
  }
})

function PerformanceAdviserPage() {
  return(
    <div className={'flex flex-col items-center justify-center'}>
      <Authorisation roles={[ROLES.ROLE_ELEVATION]} permissions={[]} forbiddenFallback={<Unauthorized />}>
        <PerformanceAdviser />
      </Authorisation>
    </div>
  )
}
